module.exports = __webpack_public_path__ + "img/skin_menu_right.598235da.png";